import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'
import _ from 'lodash'

export class UtilityService {
  async getAllUtility(account_id) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/utilities/all`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getAllUtilityByCountry(account_id, country) {
    try {
      const response = await service.get(
        Urls.getApiUrl(
          `admin/${account_id}/utilities?country=${country}`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
      )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  //server endpoint api execution function to post user sign in details for response from server
  async postProgramFilesRequest({
    program_enrollment_form_metadata_id,
    file,
    program_file_key,
    accountId,
  }) {
    var data = new FormData()
    data.append('file', file)
    data.append('program_file_key', program_file_key)
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    return await service
      .post(
        Urls.getApiUrl(
          `admin/${accountId}/programenrollmentforms/${program_enrollment_form_metadata_id}/programfile/upload`,
          MICROSERVICES.PROGRAMMANAGER,
        ),
        data,
        config,
      )
      .then((data) => data)
      .catch((error) => error)
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async getProgramMetadataOfCurrentProgramAPICall(
    programEnrollmentMetadataId,
    accountId,
  ) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    return await service
      .get(url)
      .then((data) => data)
      .catch((error) => error)
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async deleteProgramFileAPICall({
    programEnrollmentMetadataId,
    program_file_key,
    accountId,
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/delete`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    url += '?program_file_key=' + program_file_key
    return await service
      .delete(url)
      .then((data) => data)
      .catch((error) => error)
  }

  //server endpoint api execution function to get all systems as response from server - PUT method
  async downloadProgramFileAPICall({
    programEnrollmentMetadataId,
    program_file_key,
    accountId,
  }) {
    let url = Urls.getApiUrl(
      `admin/${accountId}/programenrollmentforms/${programEnrollmentMetadataId}/programfile/download`,
      MICROSERVICES.PROGRAMMANAGER,
    )
    url += '?program_file_key=' + program_file_key
    return await service
      .get(url)
      .then((data) => data)
      .catch((error) => error)
  }
}

export const utilityService = new UtilityService()
